import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import MainBody from "../../../../component/MainBody";
import MyDataTable from "../../../../component/MyDataTable";
import Switch from "../../../../component/Switch";
import httpRequest from "../../../../utils/Http";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CallTypeGroup = () => {
  const [reloadList, setReload] = useState(true);
  const [callTypeGroupName, setCallTypeGroupName] = useState("");
  const [formData, setFormData] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [isOpenForm, setOpenForm] = useState(false);
  const [isSubmit, setSubmit] = useState(false);

  const updateHandler = (id, name, is_part_order) => {
    setCallTypeGroupName(name);
    setFormData({ ...formData, id, is_part_order, type: name });
    setOpenForm(true);
  };

  const columns = [
    {
      name: "SNo.",
      selector: (row, index) => index + 1,
    },
    {
      name: "Type",
      selector: (row) => row.type,
      wrap: true,
    },
    {
      name: "Spare Allowed",
      selector: (row) => (Number(row.is_part_order) === 1 ? "YES" : "NO"),
    },
    {
      name: "Status",
      selector: (row) =>
        Number(row.is_active) === 1 ? "Activated" : "DeActivated",
      cell: (row) => (
        <Switch
          isOn={Number(row.is_active) === 1 ? true : false}
          id={row.id}
          handleToggle={(e) => {
            updateToggleHandler(row.id, e.target.checked);
          }}
          onColor="#EF476F"
        />
      ),
    },
    {
      name: "Create Date",
      selector: (row) => new Date(row.createdAt).toDateString(),
    },
    {
      name: "Update",
      cell: (row) => (
        <button
          className="booking-table-action-btn booking-table-action-btn--primary"
          onClick={() => {
            updateHandler(row.id, row.type, row.is_part_order);
          }}
        >
          <i className="fas fa-edit" aria-hidden="true"></i>
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      exportXlsx: false,
    },
  ];

  const updateToggleHandler = async (id, value) => {
    try {
      setReload(false);
      let postData = {
        id,
        is_active: value === true ? 1 : 0,
      };
      const data = await httpRequest(
        "updatecalltypegroupstatus",
        postData,
        "POST",
      );

      if (data.status === true && data.message) {
        setReload(true);

        toast.success(data.message);
      } else {
        toast.error(data.message);
        console.log(data.message);
      }
    } catch (error) {}
  };
  const closeForm = () => {
    setOpenForm(false);
  };

  const validateFrom = (value) => {
    const errors = {};
    if (!value.type) {
      errors.type = "Type is required";
    }

    return errors;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();
    setFormErrors(validateFrom(formData));
    setSubmit(true);
    //console.log(formData);
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      setSubmit(false);
      (async () => {
        const data = await httpRequest(
          "addupdatecalltypegroup",
          formData,
          "POST",
        );

        if (data.status === true && data.message) {
          setReload(true);

          toast.success(data.message);
          setCallTypeGroupName("");
          setFormData("");
          closeForm();
        } else {
          toast.success(data.message);
        }
      })();
    }
    //eslint-disable-next-line
  }, [formErrors, isSubmit]);

  const formAddUpdate = () => {
    return (
      <>
        <div className="form-overlay">
          <div className="form-container" style={{ maxWidth: "500px" }}>
            <div className="form-content">
              <form id="assignPartner" onSubmit={onSubmitHandler}>
                <div className="row">
                  <div className="col-lg-12">
                    <div className="card" style={{ marginBottom: "0px" }}>
                      <div className="card-header">
                        <h3 className="card-title">
                          {formData.id
                            ? "Update Calltype Group"
                            : "Add Calltype Group"}
                        </h3>
                        <button
                          className="btn btn-sm btn-dark"
                          onClick={closeForm}
                          style={{ float: "right" }}
                        >
                          X
                        </button>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="form-group">
                              <label>
                                Type *{" "}
                                <span style={{ color: "red" }}>
                                  {formErrors.type}
                                </span>
                              </label>
                              <input
                                type="text"
                                className={
                                  !formErrors.type
                                    ? "form-control form-icon-input text-capitalize"
                                    : "is-invalid form-icon-input form-control text-capitalize"
                                }
                                defaultValue={callTypeGroupName}
                                name="type"
                                placeholder="Enter Type"
                                id="type"
                                onChange={(e) => {
                                  setFormData({
                                    ...formData,
                                    [e.target.name]: e.target.value,
                                  });
                                }}
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label>Spare Allow</label>
                            <input
                              type="checkbox"
                              checked={formData.is_part_order || false}
                              className="form-control col-md-3"
                              id="checkboxPrimary1"
                              onChange={(e) => {
                                setFormData({
                                  ...formData,
                                  is_part_order: e.target.checked,
                                });
                              }}
                              name="is_part_order"
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className="card-footer text-center"
                        style={{
                          marginBottom: "60px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <button
                          type="submit"
                          id="submit"
                          className="btn btn-primary col-md-12"
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <div>
      <MainBody
        breadcrumbTitle="Calltype Group"
        breadcrumbSubTitle={"List"}
        navButton={""}
        title={""}
        component={
          <>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12 col-sm-12">
                    <div className="card" style={{ padding: "10px" }}>
                      <div className="card-header">
                        <h3 className="card-title">Calltype Group List</h3>
                        <Link
                          className="btn btn-sm btn-primary float-right"
                          to={"#"}
                          onClick={() => {
                            setOpenForm(true);
                            setFormData({});
                            setCallTypeGroupName("");
                          }}
                        >
                          Add Calltype Group
                        </Link>
                      </div>
                      <div className="card-body">
                        <MyDataTable
                          reloadList={reloadList}
                          columns={columns}
                          getDataListURL={"getcalltypegrouplist?is_active=all"}
                          setReload={setReload}
                          exportName={"calltypegrouplist"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {isOpenForm && formAddUpdate()}
            </section>
          </>
        }
      />
    </div>
  );
};

export default CallTypeGroup;
